/** Wavetable catalog / runtime shapes (host + kernel). */

export const WAVETABLE_FRAME_SIZE = 2048;
export const WAVETABLE_MAX_FRAMES = 256;
export const WAVETABLE_MAX_UNISON = 9;

export type WavetableCatalogEntry = {
  id: string;
  name: string;
  source: "file" | "procedural";
  pack?: "krc" | "bvker";
  /** Asset path under apps/audio-lab/assets/ (file tables only). */
  path?: string;
  /** UI group label. */
  group?: string;
  /** Known at catalog time for procedural; file tables may omit until loaded. */
  frameCount?: number;
};

/** Decoded table transferred into the kernel. */
export type WavetableRuntimeTable = {
  id: string;
  frameSize: typeof WAVETABLE_FRAME_SIZE;
  frameCount: number;
  /** Flat PCM: frameCount * frameSize samples in [-1, 1]. */
  samples: Float32Array;
};
